import actions from './actions';
import getters from './getters';
import mutations from './mutations';
import { State, FilterBy, SortBy, EventListFilter, ListPageType, RepeatingEventFilterItemsEnum } from './types';

export const getInitialState = () => ({
  events: {},
  searchTerm: '',
  filterBy: FilterBy.UpcomingEvents,
  sortBy: SortBy.EventDateDescending,
  workspaceId: '',
  repeatingEventFilter: RepeatingEventFilterItemsEnum.SHOW,
  selectedTagIds: [],
  isLoading: false,
  currentPage: 1,
  eventsPerPage: 25,
  eventsCount: 0,
  currentEventId: '',
  isUpdateEventLoading: false,
  isIntegrationTemplateDataLoadingAndUpdatingEvent: false,
  eventTypes: EventListFilter.AllEvents,
  lastOpenedPage: ListPageType.Event
});

const state: State = getInitialState();

export default {
  state,
  getters,
  mutations,
  actions,
  namespaced: true
};
